<template>
	<div class="asiatop10" id="asiatop10">
		<section class="asiatop10-top">
			<a class="bw-logo" href="http://www.cosmopolitan.com.tw/" target="_blank"><img src="../assets/images/bw-logo.png" alt=""></a>
			<img v-if="screenWidth>1200" src="../assets/images/asiatop10-title.png" alt="" class="asiatop10-title">
			<img v-else src="../assets/images/asiatop10-title-m.png" alt="" class="asiatop10-title-m">
		</section>
		<section class="asiatop10-pd-container">
			<div class="trigger-area">
				<img v-if="screenWidth<1200" src="../assets/images/asiatop10-logo.png" alt="" class="cosmo-logo-asia">
				<img v-if="screenWidth>1200" src="../assets/images/asiatop10-pd.png" alt="" class="asiatop10-pd">
				<img v-else src="../assets/images/asiatop10-pd-m.png" alt="" class="asiatop10-pd-m">
				<div class="trigger-madal" :class="'trigger-madal-item'+index" v-for="(product,index) in asiatop10Product" :key="product.no" v-on:click="saveModalShowPd(product)" data-toggle="modal" data-target="#Modal"> {{ product.product }} </div>
			</div>
		</section>
			<Modal :modalShownSon="modalShown" :votePageShowPd="modalPdFlag" :imgUrl="cosmoUrl" :sendPage="'asiatop10'"  ></Modal>
	</div>
</template>

<script>
import Modal from '../components/Modal'
var VueScrollTo = require('vue-scrollto')
export default{
	name: 'asiatop10',
	data(){
		return {
			modalShown: false,
			modalPdFlag : {},
			asiatop10Product:{
				1:{
					"no":1,
					"brand":"CHANEL香奈兒",
					"product":"嘉柏麗香水",
					"price":"50ml NT.4360 , 100ml NT.6270",
					"capacity" :"",
					"image": "top10-1.jpg",
					"detail":"香奈兒嘉柏麗香水是一款優雅大方的香水，專為不畏他人眼光、選擇走出自我道路的女性打造，邀請所有女性肯定自我價值，對實現人生目標充滿信念，展現最真實的自我。如此的氣度與自信，正是女性堅不可摧的能量泉源，促使女性懷抱滿腔熱情，大膽成就自我。",
				},
				2:{
					"no":2,
					"brand":"Clé de peau BEAUTÉ 肌膚之鑰",
					"product":"無齡光采防曬霜 SPF 50+ PA++++",
					"price":"NT.3300",
					"capacity" :"",
					"image": "top10-2.jpg",
					"detail":"高係數防曬，提供肌膚對於UVA / UVB之保護，使肌膚不易產生UVA射線所造成的細紋與暗沉，並防護肌膚不受UVB之紫外線傷害，柔滑舒適的使用感，提供豐潤的保濕、修護。使肌膚充滿光澤，柔嫩，散發迷人光采。"
				},
				3:{
					"no":3,
					"brand":"Dior迪奧",
					"product":"花植水漾精華凝霜",
					"price":"NT.2600",
					"capacity" :"50ml ",
					"image": "top10-3.jpg",
					"detail":"採用天然純淨花植成分，以簡約配方與精準功效，為肌膚深層注水保濕，賦予肌膚健康防禦力；蘊含能平衡皮膚菌落、維護好菌的天然「巴爾幹苣苔萃取」，以及強化肌底水循環的迪奧花園「錦葵精華」。雙重成分相互作用，促使肌膚和皮膚菌落達到完美平衡，提升肌膚保水度。"
				},
				4:{
					"no":4,
					"brand":"ESTEE LAUDER 雅詩蘭黛",
					"product":"特潤眼部超級精華",
					"price":"NT.2600",
					"capacity" :"15ml ",
					"image": "top10-4.jpg",
					"detail":"以全新「360°彈力支撐網科技(360°Matrix Technology™)」獨家專利打造的跨時代高效能性配方，以超彈力聚合物與兩倍超濃縮的複合玻尿酸為基底打造而成創造最強眼周避震系統，360度支撐眼部肌膚，避免細微肌肉運動所導致的眼周老化現象，全面提拉還原青春明眸。"
				},
				5:{
					"no":5,
					"brand":"La Mer海洋拉娜",
					"product":"濃縮精華露",
					"price":"NT.4700",
					"capacity" :"150ml ",
					"image": "top10-5.jpg",
					"detail":"全新海洋拉娜濃縮精華露宛如肌膚的「能量水」，可啟動肌膚的天然再生機制。濃縮精華露能讓肌膚浸潤於傳奇的濃縮精華Miracle BrothTM中，賦予肌膚展現強大美麗轉變的關鍵步驟，蘊藏四大活膚功效— 再生修護、保濕滋養、舒緩調理、勻亮膚色，如同肌膚的能量電池，為肌膚活力充電，讓後續保養產品發揮極致功效。"
				},
				6:{
					"no":6,
					"brand":"LANCÔME蘭蔻",
					"product":"絕對完美唇膏 水潤光感",
					"price":"NT.1150",
					"capacity" :"",
					"image": "top10-6.jpg",
					"detail":"絕對完美唇膏只要彈指輕壓金色華麗玫瑰符號，就能開啟盒蓋的精品釉黑管身設計，因韓劇而熱賣到全球一度斷貨的超人氣粉玫瑰色#264不只甜美，更多了個性與俏皮美感，是喜愛自然妝感的女性必備。"
				},
				7:{
					"no":7,
					"brand":"LANEIGE蘭芝",
					"product":"睡美人香氛水凝膜-淨亮保濕升級版 Water Sleeping Mask ",
					"price":"NT.990",
					"capacity" :"70ml ",
					"image": "top10-7.jpg",
					"detail":"獨家研發晚安淨化科技SleeptoxTM，利用夜晚肌膚美容黃金時段，修護因日間壓力及外在環境摧殘造成的疲憊肌膚，激活肌膚淨化肌因，喚醒肌膚新生能量；包膜鎖水科技Moisture WrapTM整夜持續封存水份不流失，同時有效穩定淨化成分，持續深入肌底；溫和配方可徹夜鎮定敏感發紅現象，專利好眠香氛SleepscentTM兼具助眠及放鬆紓緩功效，即使熬夜，仍能打造如睡眠充足般的透亮水潤熟眠美肌！"
				},
				8:{
					"no":8,
					"brand":"SHISEIDO資生堂國際櫃",
					"product":"時尚色繪尚質長效精華粉蜜SPF20",
					"price":"NT.1400",
					"capacity" :"30ml ",
					"image": "top10-8.jpg",
					"detail":"內含透明修飾聚合物，配方輕盈具高黏性能服貼肌膚，並以其高度擴散光特性，藉由補光修飾毛孔、細紋等粗糙紋理。並添加多種天然植物萃取，包括小連翹萃取精華、野百里香萃取精華，結合保養成份水分感應聚合物+甘油，其高度生物相容成分能偵測環境周圍的濕度與肌膚水分，在乾燥環境中達到加強保濕作用。"
				},
				9:{
					"no":9,
					"brand":"Sisley",
					"product":"抗皺活膚眼唇霜",
					"price":"NT.5600",
					"capacity" :"15ml ",
					"image": "top10-9.jpg",
					"detail":"30歲以上的任何肌膚，甚至眼部特別敏感性者也適合使用。海扇藻萃取刺激真皮層彈力水合膠質合成，減少細紋、皺紋的產生，回復肌膚的緊實與彈性。維他命F萃取自乳油木仁及芝麻，改善皮膚質地及緊實感，強化皮膚天然障壁及保有最大保濕度。有效對抗黑眼圈、浮腫以及肌膚鬆弛現象，恢復肌膚彈性、減少皺紋產生。註：2017.9.1推出SISLEY抗皺活膚御緻眼唇霜，抗皺活膚眼唇霜已無販售。"
				},
				10:{
					"no":10,
					"brand":"SK-II",
					"product":"超肌因鑽光淨白精華",
					"price":"NT.4600",
					"capacity" :"30ml ",
					"image": "top10-10.jpg",
					"detail":"以「肌因光感科學」為肌底注入獨家「鑽光淨白複方top」，徹底深入肌膚底層深層修護，精準掌握UV10大傷害，打造無瑕的鑽光淨白肌膚。西梅果萃取 NEW富含優良抗氧化功效，能徹底清除細胞內沉積黑色素，搭配PITERA TM促進肌膚角質層的新陳代謝狀況，幫助黑色素正常代謝避免堆積，使蛋白母細胞健康飽滿、肌膚更加透亮。"
				}
			}
		}
	},
	props:{
		cosmoUrl: String,
		screenWidth: Number
	},
	components:{
		Modal
	},
	watch:{

		modalShown(value){
          let self = this 
          self.modalShown = value
	  },

	},
	created (){
	
	},
	mounted(){
		let scroll_e = VueScrollTo.scrollTo('.asiatop10')
	},
	 methods:{
		 saveModalShowPd: function(pd){
			//  console.log(pd)
			 let self = this 
			 self.modalPdFlag = pd 
		 },
		 toggleModalFlag: function(pdId){
			let self = this
			self.modalShown = !self.modalShown
			// console.log(self.modalShown)
		},
	 }
}
</script>

<style lang="sass" scoped>
$main-color: #f21290
@mixin rwd($w)
	@media only screen and (max-width: $w) 
		@content
		
.asiatop10 
	// background-image: url(../assets/images/d-bg.jpg)
	// background-position: 50% 0
	// background-size: cover
	// background-repeat: no-repeat
	// background-attachment: fixed
	padding-bottom: 100px
.asiatop10-top 
	width: 100%
	height: 600px
	position: relative
	// overflow: hidden
	padding-top: 21px
	background-color: #000
	z-index: 1
	padding-top: 64px
	img 
		margin: 0 auto
	&:after
		content: ''
		position: absolute
		z-index: -1
		top: 0
		left: calc(50% - 1280px)
		height: 684px
		width: 2560px
		background-image: url(../assets/images/d-page-kv.png)
		background-position: 50% 0
		background-size: cover
		background-repeat: no-repeat
	// &:before
	// 	content: ''
	// 	position: absolute
	// 	left: 0
	// 	bottom: -600px
	// 	width: 100%
	// 	height: 600px
	// 	background: linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -moz-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -o-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	.bw-logo
		height: 54px
		position: absolute
		top: 21px
		left: calc(50% - 600px)
		img 
			height: 100%
.asiatop10-pd-container
	width: 100%
	margin: 0 auto
	// height: 800px
	margin-top: -340px
	z-index: 5

.cosmo-logo-asia
	position: absolute
	top: 25%
	left: calc(50% - 143px)
.asiatop10-title,
.asiatop10-pd
	margin: 0 auto
.trigger-area
	width: 1058px
	margin: 0 auto
	position: relative
	z-index: 3
	img 
		margin: 0 auto
.trigger-madal
	position: absolute
	width: 250px
	height: 250px
	cursor: pointer
	color: transparent
	font-size: 22px
.trigger-madal-item1
	top: 15%
	left: 11%
	&:after 
		content: ''
		position: absolute
		left: 100%
		top: -5%
		width: 80px
		height: 120px
.trigger-madal-item2
	bottom: 16%
	left: 15%
.trigger-madal-item3
	top: 0%
	right: 5%
	height: 200px
	
.trigger-madal-item4
	right: 0
	top: 28%
	width: 220px
.trigger-madal-item5 
	left: 39%
	width: 220px
	bottom: 8%
	height: 270px
.trigger-madal-item6 
	top: -5%
	left: 42%
.trigger-madal-item7 
	right: 20%
	top: 23%
	width: 200px
	height: 220px
.trigger-madal-item8 
	left: 0
	top: 0
	width: 140px
	height: 270px
	&:after 
		content: ''
		position: absolute
		left: 100%
		top: 0
		width: 100px
		height: 120px
.trigger-madal-item9 
	left: 0
	bottom: 40%
	width: 190px
	height: 200px
.trigger-madal-item10
	right: 17%
	bottom: 15%

+rwd(1200px)
	.asiatop10-top 
		width: 100%		
		background-image: url(../assets/images/m-page-kv-n.png)
		background-position: 50% 0	
		background-size: 100%
		background-color: transparent
		background-repeat: no-repeat
		padding: 0
		padding-top: 183px
		height: auto
		padding-bottom: 14px
		&:after 
			display: none
		.bw-logo 
			height: auto 
			left: 35px
		.asiatop10-title 
			padding-top: 144px
			margin-bottom: 20px	
	.asiatop10-pd-container
		margin-top: 0
	.trigger-area
		width: 100%
		.cosmo-logo-asia
			position: static
			margin-top: 46px	
	.trigger-madal
		width: 320px
		height: 350px
	.trigger-madal-item1
		top: 16%
		left: 6%
		&:after 
			display: none

	.trigger-madal-item2
		top: 42%
		left: 0%
		width: 280px
	.trigger-madal-item3
		left: 0
		bottom: 20%
		top: auto
		height: 250px
	.trigger-madal-item4
		top: 44%
		width: 250px

	.trigger-madal-item5 
		bottom: 8.5%
		left: 42%
		width: 210px
		height: 470px
	.trigger-madal-item6 
		top: 20%
		width: 200px
		left: 45%
	.trigger-madal-item7 
		top: 45%
		height: 300px
		width: 220px
		left: 36%
	.trigger-madal-item8 
		left: auto
		right: 0
		top: 15%
		width: 200px
		height: 380px
		&:after 
			display: none
	.trigger-madal-item9 
		bottom: 0%
	.trigger-madal-item10
		right: 0
		bottom: 5%
		width: 220px
		height: 370px

</style>



// WEBPACK FOOTER //
// Asiatop10.vue?7d1fd0e6